import styled from "styled-components";
import { FormContainer, FormHeading, FormText } from "./Form";

type ConfirmRegistrationProps = {
  title: string;
  message: string;
};

const ConfirmationMessage = styled.div`
  text-align: center;
  margin: 48px 0;
`;

const EmailIcon = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"
      fill="currentColor"
    />
  </svg>
);

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
`;

export const Confirmation = ({ title, message }: ConfirmRegistrationProps) => {
  return (
    <FormContainer>
      <ConfirmationMessage>
        <IconWrapper>
          <EmailIcon />
        </IconWrapper>
        <FormHeading>{title}</FormHeading>
        <FormText>{message}</FormText>
      </ConfirmationMessage>
    </FormContainer>
  );
};
